export enum ExportType {
    WORKS = 'works',
    MATCH_HISTORY = 'match-history',
    MATCH_RECORDINGS = 'match-recordings',
    OVERCLAIMS = 'overclaims',
    SONGWRITER_WORKS = 'songwriter-works',
    REGISTRATION_HISTORY = 'registration-history',
}
